import { createStyles } from './style-object.es.js';
var camelLetterToPipeLetter = function camelLetterToPipeLetter(letter) {
  return "-".concat(letter.toLowerCase());
};
var camelToPipeCase = function camelToPipeCase(str) {
  return str.replace(/[A-Z]/g, camelLetterToPipeLetter);
};
function createStyleString() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var styles = createStyles(target);
  var style = "";
  for (var key in styles) {
    style += key.startsWith("--") ? key : camelToPipeCase(key);
    style += ": ".concat(styles[key], "; ");
  }
  return style;
}
export { createStyleString };